








































import { Component, Vue, Watch } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import UserTokensList from '@/components/prescriber/UserTokensList.vue';

@Component({
    components: {
        VxBreadcrumb,
        UserTokensList,
    },
})
export default class UserTokens extends Vue {}
